export const UPDATE_HEADERS_AMPLIFY_PROP = 'custom_header'
export const REST_API_NAME = 'rest-api'
export const DOWNLOAD_API_NAME = 'download-api'
